module.exports = __webpack_public_path__ + "static/media/Header_Image_Mobile.b1d089ca.png";